import { Component, EventEmitter, Input, OnDestroy, Output, ChangeDetectionStrategy } from '@angular/core';

import { fromEvent, Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';

import { CatalogEntry } from '@apps/its2/models';
import { PopupTreeviewRef } from '@ui/components/form/controls/input/input-treeview2/popup-treeview-ref';

import { TreeModel } from '../../../treeview';

@Component({
    selector: 'aa-popup-treeview',
    templateUrl: './popup-treeview.component.html',
    styleUrls: [
        './popup-treeview.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupTreeviewComponent implements OnDestroy
{
    @Input() treeModel: TreeModel;
    @Input() catalogEntry: CatalogEntry;
    @Input() width: number;
    @Input() height: number;
    @Output() itemSelected: EventEmitter<CatalogEntry> = new EventEmitter<CatalogEntry>();
    @Output() clickedOutside: EventEmitter<boolean> = new EventEmitter<boolean>();
    private destroyator = new Subject();

    constructor (private popupTreeviewRef: PopupTreeviewRef)
    {
        fromEvent(document, 'click')
            .pipe(
                filter((event: MouseEvent) =>
                    this.clickOutside(event)
                ),
                tap(() =>
                    this.clickedOutside.emit(true)
                ),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }

    ngOnDestroy (): void
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    public onItemSelected (item: any): void
    {
        this.itemSelected.emit(item);
    }

    private clickOutside (event: any): boolean
    {
        const boundingClientRect = this.popupTreeviewRef.myGetBoundingClientRect();

        if (boundingClientRect !== undefined)
        {
            const { top, bottom, left, right } = boundingClientRect;
            const { x, y } = event;

            const isInsideX = x >= left && x <= right;
            const isInsideY = y >= (top - 50) && y <= bottom;

            return !(isInsideX && isInsideY);
        }
    }
}
